import type { ContentfulContentGroupFragment } from '@/graphql/contentful/api';
import type { CmsExtraDataRecord } from '@/integrations/contentful';

import { renderContentfulContentGroupSection } from './cms';

export type ContentGroupProps = ContentfulContentGroupFragment & {
  extraDataRecord?: CmsExtraDataRecord;
};

export const ContentGroup = (props: ContentGroupProps) => {
  return (
    <>
      {props.id ? (
        <div id={props.id}>{renderContentfulContentGroupSection(props)}</div>
      ) : (
        renderContentfulContentGroupSection(props)
      )}
    </>
  );
};
